import { ArrowRight } from "lucide-react";
import { useSiteContent } from "@/lib/siteContent";

const STEPS = [
  { n: "01", title: "Learn the possibilities.", body: "You'll see exactly what AI and no-code tools can help you build — websites, apps, dashboards, funnels, and more." },
  { n: "02", title: "Map the idea.", body: "Turn that messy idea sitting in your notebook into a clear, structured digital build plan." },
  { n: "03", title: "Build live.", body: "We walk through the process in real time so you see how the tools actually work — and start building yours." },
  { n: "04", title: "Leave with momentum.", body: "Walk away with a stronger understanding of what to build, how to build it, and how this skill can support your business or future income." },
];

export default function HowItWorks() {
  const sc = useSiteContent();
  return (
    <section id="how" data-testid="how-it-works-section" className="relative py-24 lg:py-32 bg-bone border-y border-[var(--line)]">
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-7">
            <div className="eyebrow mb-5">The Experience</div>
            <h2 className="font-display text-[44px] sm:text-5xl lg:text-[72px] leading-[1.02] tracking-[-0.035em] text-ink">
              What happens in the{" "}
              <span className="font-serif-em italic text-brand font-light">{sc.lab_duration_label}</span>{" "}
              live build lab.
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="text-[17px] leading-relaxed text-ink/70">
              Not a webinar. Not a video drop. {sc.lab_duration_label} of intentional time where you watch, plan, and build alongside us — live.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-[var(--line)] border border-[var(--line)] rounded-3xl overflow-hidden">
          {STEPS.map((s, i) => (
            <div key={s.n} data-testid={`step-${i}`} className="bg-white p-8 lg:p-10 relative group transition-colors hover:bg-bone">
              <div className="flex items-start justify-between mb-10">
                <span className="font-mono-spec text-xs text-[var(--muted)] tracking-wider">{s.n}</span>
                <div className="w-8 h-8 rounded-full border border-[var(--line)] grid place-items-center text-ink/40 group-hover:bg-ink group-hover:text-white group-hover:border-ink transition-all">
                  <ArrowRight size={14} />
                </div>
              </div>
              <h3 className="font-display text-2xl sm:text-3xl tracking-[-0.025em] text-ink mb-3 leading-tight">{s.title}</h3>
              <p className="text-ink/70 leading-relaxed text-base">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
